import { EntitiesResponse } from '@/types/entity'
import { defineStore } from 'pinia'

interface States {
  brands: Ref<EntitiesResponse | null>
  retailers: Ref<EntitiesResponse | null>
  accounts: Ref<EntitiesResponse | null>
}

export const useEntityStore = defineStore('entity', () => {
  const states: States = {
    brands: ref(null),
    retailers: ref(null),
    accounts: ref(null),
  }

  const resetStore = () => {
    states.brands.value = null
    states.retailers.value = null
    states.accounts.value = null
  }

  return {
    ...states,
    resetStore,
  }
})
